<template>

    <div class="d-flex justify-content-end p-05" id="accept-reject-buttons" style="width: 100%">
        <div class="pr-05">
            <a @click.prevent="accept"
               class="btn btn-success waves-effect waves-light white"
               id="accept">
                <i class="fas fa-sign-in-alt"></i> ACCEPT INVITE </a>
        </div>
        <div class="pr-05">
            <a @click.prevent="reject"
               class="btn btn-danger waves-effect waves-light white"
               id="reject">
                <i class="fas fa-times"></i> REJECT INVITE </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "Accept-Reject",
    props: ['data', 'service'],
    data() {
        return {
            user: window.App.user,
            module: this.data,
            section: this.service
        }
    },
    methods: {
        accept() {
            axios.get('/member/' + this.section + '/' + this.module.slug + '/accept/' + this.user.username)

            $('#accept-reject-buttons').html('You have accepted the request');
            setTimeout(function () {
                $('#accept-reject-buttons').css('display', 'none')
            }, 5000);
        },
        reject() {
            axios.get('/member/' + this.section + '/' + this.module.slug + '/reject/' + this.user.username);

            $('#accept-reject-buttons').html('You have rejected the request');
            setTimeout(function () {
                $('#accept-reject-buttons').css('display', 'none')
            }, 5000);
        }
    },
}
</script>

<style scoped>

</style>
